<template>
    <div class="sampleNumberToKorean">
        <h1>numberToKorean</h1>
        <el-input v-model="value" placeholder="금액을 입력하시오"></el-input><br>
        {{value | numberToKorean}}
    </div>
</template>

<script>
export default {  
    name: 'sampleNumberToKorean',
    data() {
        return {
            value:10000
        }
    },
};
</script>
